import React from "react";
import "./ImageCheckbox.css";

const ImageCheckbox = ({ imageOptionSelected, handleImageOptions, question, questions, isInError }) => {
  return (
    <div className="imageCheckboxContainer">
      <div
        className={
          "imageCardContainer" +
          (imageOptionSelected === "Stomach" ? " imageCardSelected " : "") +
          (isInError ? " container_error" : "")
        }
        onClick={() => handleImageOptions(question, "Stomach", questions)}
      >
        <div className="imageCard pronePosition"></div>
        <div className="imageText">Stomach</div>
      </div>
      <div
        className={
          "imageCardContainer" +
          (imageOptionSelected === "Back" ? " imageCardSelected " : "") +
          (isInError ? " container_error" : "")
        }
        onClick={() => handleImageOptions(question, "Back", questions)}
      >
        <div className="imageCard supinePosition"></div>
        <div className="imageText">Back</div>
      </div>
      <div
        className={
          "imageCardContainer" +
          (imageOptionSelected === "Right Lateral" ? " imageCardSelected " : "") +
          (isInError ? " container_error" : "")
        }
        onClick={() => handleImageOptions(question, "Right Lateral", questions)}
      >
        <div className="imageCard rightLateralPosition"></div>
        <div className="imageText">Right Side</div>
      </div>
      <div
        className={
          "imageCardContainer" +
          (imageOptionSelected === "Left Lateral" ? " imageCardSelected " : "") +
          (isInError ? " container_error" : "")
        }
        onClick={() => handleImageOptions(question, "Left Lateral", questions)}
      >
        <div className="imageCard lateralPosition"></div>
        <div className="imageText">Left Side</div>
      </div>
    </div>
  );
};

export default ImageCheckbox;
